import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetting, setResetting] = useState(false);

  const onReset = async () => {
    if (!email) {
      toast.error("Bitte zuerst die E-Mail-Adresse eingeben.");
      return;
    }
    setResetting(true);
    await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/admin/passwort`,
    });
    setResetting(false);
    toast.success("Falls ein Zugang existiert, wurde eine E-Mail mit einem Link verschickt.");
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const generic = "E-Mail oder Passwort ungültig";
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error || !data.user) {
      toast.error(generic);
      setLoading(false);
      return;
    }
    const { data: role } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", data.user.id)
      .eq("role", "admin")
      .maybeSingle();
    if (!role) {
      await supabase.auth.signOut();
      toast.error(generic);
      setLoading(false);
      return;
    }
    toast.success("Willkommen zurück");
    navigate("/admin");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary px-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-2xl font-bold text-foreground mb-2">Admin Login</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Bitte melde dich an, um das Magazin zu verwalten.
        </p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Passwort</Label>
            <Input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "Anmelden…" : "Anmelden"}
          </Button>
          <button
            type="button"
            onClick={onReset}
            disabled={resetting}
            className="w-full text-sm text-muted-foreground hover:text-foreground underline underline-offset-4"
          >
            {resetting ? "Wird gesendet…" : "Passwort vergessen?"}
          </button>
        </form>
      </Card>
    </div>
  );
};

export default AdminLogin;
